export const albumUriValidationRegex =
  /^[A-Za-z0-9:=\/\\.\\?]+(?=([,;\s])|$)(?:\1[A-Za-z0-9:\/\\.]+)*$/;
